module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg5-93a2fd98b0062c3676cde597a17dfb0a.png";